import React from 'react';
import { Box, Flex } from 'rebass';
import { connectRefinementList } from 'react-instantsearch-dom';
import RefinementItem from './Item';

const BoolFilters = ({ boolFilters, ...props }) => {
  return (
    <Flex flexWrap="wrap" width={1} m={-2} p={2} {...props}>
      {boolFilters?.map(({ indicator, label, key }) => {
        return (
          <Box width={[1, 'auto']} key={key} p={2}>
            <RefinementItem
              indicator={indicator}
              label={label}
              attribute={key}
            />
          </Box>
        );
      })}
    </Flex>
  );
};

export default connectRefinementList(BoolFilters);
